import * as moment from 'moment';

const today = moment().endOf('day');
const yearAgo = moment()
  .startOf('day')
  .subtract(1, 'years');

export const defaultFilters = {
  dateFrom: yearAgo.toDate(),
  dateTo: today.toDate(),
};



// WEBPACK FOOTER //
// ./src/views/TargetCheck/services/defaultFilters.ts